var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',_vm._l((_vm.quantity),function(star){return _c('i',{key:star,staticClass:"material-icons star"},[_vm._v("star")])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }